import { request } from "../utils/request.js"

export const prePayOrder_exportForManage = (pojo, args) => request({
    url: 'prePayOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const prePayOrder_findPageForManage = (pojo, args) => request({
    url: 'prePayOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const prePayOrder_findPageListForManage = (pojo, args) => request({
    url: 'prePayOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const prePayOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'prePayOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const prePayOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'prePayOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const prePayOrder_saveIntoDraft = (pojo, args) => request({
    url: 'prePayOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'prePayOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_update = (pojo, args) => request({
    url: 'prePayOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_updateAndSubmit = (pojo, args) => request({
    url: 'prePayOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_submitById = (id, args) => request({
    url: 'prePayOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_deleteById = (id, args) => request({
    url: 'prePayOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_approval = (pojo, args) => request({
    url: 'prePayOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const prePayOrder_findById = (id, args) => request({
    url: 'prePayOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/prePayOrder.js